import { CommonModule } from '@angular/common';
import { NgModule, Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation } from '@angular/core';
import { BaseDirective } from '../../../../base.directive';

@Component({
    selector: 'eui-overlay-body',
    templateUrl: './eui-overlay-body.component.html',
    styleUrls: ['../../styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiOverlayBodyComponent extends BaseDirective {

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses(`eui-overlay-body`),
        ].join(' ').trim();
    }

    constructor (
    ) {
        super();
    }
}
